<form class="form" [formGroup]="form" (ngSubmit)="submit()">
  <ng-container *ngFor="let campo of camposVisiveis">
    <!-- Input padrão de texto -->
    <app-input class="form__input" [appearance]="appearance" [icon]="campo.icon" [label]="campo.label"
      [name]="campo.name" [mask]="campo.mask" [onChange]="campo.onChange" [style]="'width: ' + campo.width"
      *ngIf="campo.type === 'text'">
    </app-input>

    <!-- Input padrão de dinheiro -->
    <app-money-input class="form__input" [appearance]="appearance" [icon]="campo.icon" [label]="campo.label"
      [name]="campo.name" [moneyOptions]="campo.moneyOptions" [style]="'width: ' + campo.width"
      *ngIf="campo.type === 'money'">
    </app-money-input>

    <!-- Input padrão de tempo -->
    <app-time-input class="form__input" [appearance]="appearance" [icon]="campo.icon" [label]="campo.label"
      [name]="campo.name" [style]="'width: ' + campo.width" *ngIf="campo.type === 'time'">
    </app-time-input>

    <!-- Input textarea -->
    <app-textarea class="form__input" [appearance]="appearance" [icon]="campo.icon" [label]="campo.label"
      [name]="campo.name" [style]="'width: ' + campo.width" *ngIf="campo.type === 'textarea'">
    </app-textarea>

    <!-- Input de seleção -->
    <app-select-input class="form__input" [appearance]="appearance" [icon]="campo.icon" [label]="campo.label"
      [name]="campo.name" [onChange]="campo.onChange" [selectOptions]="campo.selectOptions"
      [style]="'width: ' + campo.width" *ngIf="campo.type === 'select'">
    </app-select-input>

    <!-- Input de pesquisa com seleção -->
    <app-search-input class="form__input" [appearance]="appearance" [icon]="campo.icon" [label]="campo.label"
      [name]="campo.name" [searchOptions]="campo.searchOptions" [onChange]="campo.onChange"
      [style]="'width: ' + campo.width" *ngIf="campo.type === 'search'">
    </app-search-input>

    <!-- Input de data -->
    <app-date-input class="form__input" [appearance]="appearance" [label]="campo.label" [name]="campo.name"
      [dateOptions]="campo.dateOptions" [style]="'width: ' + campo.width" *ngIf="campo.type === 'date'">
    </app-date-input>

    <!-- Input de período de data -->
    <app-date-range-input class="form__input" [appearance]="appearance" [label]="campo.label"
      [formControlName]="campo.name" [dateRangeOptions]="campo.dateRangeOptions" [style]="'width: ' + campo.width"
      [matTooltip]="campo.tooltip || ''" *ngIf="campo.type === 'date-range'">
    </app-date-range-input>

    <!-- Checkbox -->
    <app-checkbox class="form__input" [label]="campo.label" [formControlName]="campo.name"
      [style]="'width: ' + campo.width" *ngIf="campo.type === 'checkbox'" [onChange]="campo.onChange">
    </app-checkbox>

    <!-- Table -->
    <!-- TODO: Transformar em um input para recerber um formControlName -->
    <app-table class="form__input" [colunas]="campo.tableOptions.colunas" [items]="form.get([campo.name])?.value"
      [selectable]="campo.tableOptions.onSelect !== undefined" [style]="'width: ' + campo.width"
      (onSelect)="campo.tableOptions.onSelect ? campo.tableOptions.onSelect($event) : null"
      *ngIf="campo.type === 'table' && campo.tableOptions">
    </app-table>

    <!-- Table with Footer -->
    <div *ngIf="campo.type === 'table-with-footer' && campo.tableOptions" class="form__input" [style]="'width: ' + campo.width">
      <app-table
        [colunas]="campo.tableOptions.colunas"
        [items]="form.get([campo.name])?.value"
        [allItems]="campo.tableOptions.allItems"
        [selectable]="campo.tableOptions.onSelect !== undefined"
        [footerLabel]="campo.tableOptions.footerLabel"
        [footerColumns]="campo.tableOptions.footerColumns"
        (onSelect)="campo.tableOptions.onSelect ? campo.tableOptions.onSelect($event) : null">
      </app-table>
    </div>

    <!-- Paginator -->
    <app-paginator class="form__input" [style]="'width: ' + campo.width"
      [length]="form.get([campo.name])?.value?.length" [pageSize]="form.get([campo.name])?.value?.pageSize"
      [pageIndex]="form.get([campo.name])?.value?.pageIndex" (onPaginate)="
        campo?.paginatorOptions?.onPaginate ? campo.paginatorOptions.onPaginate($event) : null
      " *ngIf="campo.type === 'paginator' && campo.paginatorOptions">
    </app-paginator>

    <!-- Button -->
    <app-button class="form__input" [icon]="campo.icon" [label]="campo.label" [tooltip]="campo.buttonOptions.tooltip"
      [disabled]="campo.disabled" [style]="'width: ' + campo.width"
      (onClick)="campo.buttonOptions.onClick ? campo.buttonOptions.onClick() : null"
      *ngIf="campo.type === 'button' && campo.buttonOptions">
    </app-button>

    <!--- Telefone -->
    <app-telefone-intl [disabled]="campo.disabled ?? false" class="form__input" labelCustom="Telefone" [control]="form.get([campo.name])"
      [style]="'width: ' + campo.width" *ngIf="campo.type == 'telefone'"> </app-telefone-intl>

    <!-- Separador -->
    <app-separator class="form__input" [label]="campo.label" *ngIf="campo.type === 'separator'">
    </app-separator>
  </ng-container>
</form>